var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import widgetsDictionary from "@/components/widgets/widgetsDictionary";
import { useGetAllMenuQuery, useGetModuleFieldLayoutQuery, useGetModuleFieldsQuery, useGetRelationshipWithContactQuery, } from "@/store/api";
import { Dropdown, Input, Menu, MenuButton } from "@mui/joy";
import queryString from "query-string";
import { useEffect, useMemo, useState } from "react";
import { useGetModuleListQuery } from "@/store/api";
import { Link } from "react-router-dom";
import ConcatLine from "./concatLine";
import WidgetSelector from "../filters/selector";
import ModuleList from "./moduleList";
import { SlotDirection } from "@/utils/types/layout";
import { useLayout } from "@/hooks/layout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDownToSquare, faClose, faList, } from "@fortawesome/pro-solid-svg-icons";
import { slotDirection } from "@/utils/funcs";
import { useTranslation } from "react-i18next";
export default function WidgetList(_a) {
    var _b, _c, _d, _e;
    var widget = _a.widget;
    var module = ((_b = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _b === void 0 ? void 0 : _b.module) || "Accounts";
    var filters = ((_c = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _c === void 0 ? void 0 : _c.selectedFilters) || [];
    var recordId = ((_d = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _d === void 0 ? void 0 : _d.recordId) || "";
    var isDrawer = (widget === null || widget === void 0 ? void 0 : widget.slot) && (widget === null || widget === void 0 ? void 0 : widget.slot.includes("DRAWER"));
    var t = useTranslation(["common"]).t;
    var _f = useGetRelationshipWithContactQuery({ module: module, id: recordId }, {
        skip: !recordId,
    }), response = _f.data, isLoading = _f.isLoading, isError = _f.isError, isFetching = _f.isFetching;
    var _g = useState(filters.map(function (item) { return item.filters; })), where = _g[0], setWhere = _g[1];
    useEffect(function () {
        if (filters !== null) {
            var newWhere = filters.map(function (item) { return item.filters; });
            // Check if the newWhere is different from the current value of where
            if (JSON.stringify(newWhere) !== JSON.stringify(where)) {
                setWhere(newWhere);
            }
        }
    }, [filters, where]);
    var moduleList = useGetModuleListQuery({
        table: module,
        params: {
            sorted: [
                {
                    name: "date_modified",
                    direction: "descending",
                },
            ],
            where: where,
            pageSize: 10,
            page: 0,
        },
    }).data;
    // Get data records
    var _h = useState([]), record = _h[0], setRecord = _h[1];
    useEffect(function () {
        var _a;
        if (recordId) {
            if ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.results) {
                setRecord(response.data.results);
            }
        }
        else {
            var data = moduleList === null || moduleList === void 0 ? void 0 : moduleList.data;
            setRecord((data === null || data === void 0 ? void 0 : data.records) || []);
        }
    }, [moduleList, response]);
    // Get field_defs
    var listFields = useGetModuleFieldsQuery(module || "Accounts").data;
    var field_defs = (listFields && (listFields === null || listFields === void 0 ? void 0 : listFields.data.attributes)) || [];
    // Get view_defs
    var viewDefs = useGetModuleFieldLayoutQuery(module || "Accounts").data;
    var view_defs = (viewDefs && (viewDefs === null || viewDefs === void 0 ? void 0 : viewDefs.data.layout)) || [];
    var layout = useLayout();
    var direction = widget.slot
        ? slotDirection(widget.slot)
        : SlotDirection.VERTICAL;
    return (_jsx(_Fragment, { children: direction === "VERTICAL" ? (_jsxs("div", __assign({ className: " h-full text-[var(--colors-label)] overflow-auto    mt-[var(--margin-mt-widget)] mr-[var(--margin-mr-widget)] mb-[var(--margin-mb-widget)] ml-[var(--margin-ml-widget)]" }, { children: [isDrawer && (_jsx("span", __assign({ className: "absolute top-0 ml-0 mr-0 p-1 z-50 " }, { children: _jsx(FontAwesomeIcon, { icon: faClose, title: String(t("app.LNK_CLOSE")), onClick: function () {
                            layout.clearWidgets({
                                slots: widget.slot,
                            });
                        }, className: "cursor-pointer hover:bg-[rgb(var(--color-gray-500))] bg-[rgb(var(--color-gray-300))] rounded-sm p-0.5 w-4", color: "white" }) }))), _jsx("h2", __assign({ className: "uppercase font-bold justify-center items-center flex p-2" }, { children: (_e = widget.payload) === null || _e === void 0 ? void 0 : _e.property })), _jsx("hr", {}), _jsx("div", __assign({ className: " rounded-[calc(var(--border-widget)/2)]  bg-[var(--colors-body-bg-sec)]  " }, { children: record === null || record === void 0 ? void 0 : record.map(function (record, index) { return (_jsx(ConcatLine, { isVertical: true, widget: widget, record: record, fieldDefs: field_defs, viewDefs: view_defs }, index)); }) })), record.length <= 0 && (_jsx("div", __assign({ className: "flex-1 p-5 m-5 text-md" }, { children: _jsx("span", __assign({ className: "italic " }, { children: t("app.MSG_LIST_VIEW_NO_RESULTS_BASIC") })) }))), _jsx(Link, __assign({ to: "/modules/".concat(module), className: "float-right p-2 text-[#485fc7]" }, { children: _jsx(FontAwesomeIcon, { icon: faArrowDownToSquare }) }))] }))) : (_jsxs(Dropdown, { children: [_jsx(MenuButton, __assign({ sx: {
                        border: "none",
                        "&:hover": {
                            background: "none",
                        },
                    } }, { children: _jsx(FontAwesomeIcon, { icon: faList, size: "xl", title: "" }) })), record && (_jsx("div", __assign({ className: " text-sm " }, { children: _jsx(Menu, __assign({ sx: {
                            background: "var(--colors-widget)",
                            width: "20%",
                            maxHeight: "90%",
                            overflow: "auto",
                            textAlign: "right",
                            borderRadius: "var(--border-widget)",
                            paddingBottom: "var(--margin-mb-widget)",
                            paddingTop: "var(--margin-mt-widget)",
                            paddingLeft: "var(--margin-ml-widget)",
                            paddingRight: "var(--margin-mr-widget)",
                        } }, { children: _jsx("div", __assign({ className: " rounded-[calc(var(--border-widget)/2)]    " }, { children: record === null || record === void 0 ? void 0 : record.map(function (record, index) { return (_jsx(ConcatLine, { widget: widget, record: record, fieldDefs: field_defs, viewDefs: view_defs, isVertical: false }, index)); }) })) })) })))] })) }));
}
/**
 * Settings of this widget
 * @param widget
 * @returns
 */
function WidgetSettings(_a) {
    var _b, _c, _d, _e;
    var widget = _a.widget, onChange = _a.onChange;
    var menuResponse = useGetAllMenuQuery(null).data;
    // Memo : all modules used for translation
    var allModules = useMemo(function () {
        var _a, _b, _c, _d;
        var value = ((_d = (_c = (_b = (_a = menuResponse === null || menuResponse === void 0 ? void 0 : menuResponse.data) === null || _a === void 0 ? void 0 : _a.main) === null || _b === void 0 ? void 0 : _b.tabs) === null || _c === void 0 ? void 0 : _c.LBL_TABGROUP_ALL) === null || _d === void 0 ? void 0 : _d.modules) || {};
        return Object.keys(value);
    }, [menuResponse]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var main = ((_b = menuResponse === null || menuResponse === void 0 ? void 0 : menuResponse.data) === null || _b === void 0 ? void 0 : _b.main) || [];
    var createMenu = useMemo(function () {
        var _a, _b, _c, _d;
        var list = main || {};
        var links = (list === null || list === void 0 ? void 0 : list.links) || {};
        var moduleLinks = {};
        var modules = (_b = (_a = list === null || list === void 0 ? void 0 : list.tabs) === null || _a === void 0 ? void 0 : _a.LBL_TABGROUP_ALL) === null || _b === void 0 ? void 0 : _b.modules;
        var _loop_1 = function (moduleKey) {
            var clientLinks = {};
            var linksUrls = (_c = links[moduleKey]) === null || _c === void 0 ? void 0 : _c.links;
            var image = (_d = links[moduleKey]) === null || _d === void 0 ? void 0 : _d.image;
            linksUrls.forEach(function (element) {
                var window = {};
                var location = window.location || {};
                var protocol = location.protocol || "http";
                var host = location.host || "localhost";
                var url = new URL(element.url, process.env.ETCRM_URL || "".concat(protocol, "://").concat(host));
                var query = url.search.split("?");
                var qs = query.length > 1 ? query[1] : query[0];
                var queryParts = queryString.parse(qs);
                var newLinkParts = [];
                var module = queryParts.module || "";
                var action = queryParts.action && queryParts.action !== "index"
                    ? queryParts.action
                    : "";
                delete queryParts.module;
                delete queryParts.action;
                for (var p in queryParts) {
                    newLinkParts.push("".concat(p, "=").concat(queryParts[p]));
                }
                var q = newLinkParts.length > 0 ? "?".concat(newLinkParts.join("&")) : "";
                clientLinks[element.id] = "".concat(module, "/").concat(action).concat(q);
            });
            moduleLinks[moduleKey] = {
                links: links[moduleKey],
                clientLinks: clientLinks,
                image: image,
            };
        };
        for (var moduleKey in modules) {
            _loop_1(moduleKey);
        }
        return moduleLinks;
    }, [main]);
    var filteredMenu = function () {
        var links = [];
        var menu = createMenu;
        for (var m in menu) {
            if (menu[m].links.links.length) {
                links[m] = menu[m];
            }
        }
        return links;
    };
    var menuAll = Object.values(filteredMenu());
    var modules = {};
    menuAll.map(function (item) {
        modules[item.links.module] = item.links.label;
    });
    var filter = {
        id: "",
        type: "widget/selectorFilter",
        payload: {
            module: ((_c = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _c === void 0 ? void 0 : _c.module) || "Accounts",
            selectedFilters: (_d = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _d === void 0 ? void 0 : _d.selectedFilters,
            isInWidget: true,
        },
    };
    return (_jsxs("div", { children: [_jsxs("div", { children: [_jsx("label", __assign({ htmlFor: "content-value", id: "content-value-label" }, { children: "Title" })), _jsx(Input, { slotProps: {
                            input: {
                                id: "title-value",
                                "aria-labelledby": "title-value title-value-label",
                            },
                        }, value: (widget === null || widget === void 0 ? void 0 : widget.payload.property) || "", onChange: function (e) {
                            var value = e.target.value;
                            onChange &&
                                onChange(widget, __assign(__assign({}, widget.payload), { property: value }));
                        } })] }), _jsxs("div", { children: [" ", _jsx("label", __assign({ htmlFor: "module-type-button", id: "module-type-label" }, { children: "Module" })), _jsx(ModuleList, { module: (_e = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _e === void 0 ? void 0 : _e.module, options: modules, onChange: function (event, v) {
                            onChange && onChange(widget, __assign(__assign({}, widget === null || widget === void 0 ? void 0 : widget.payload), { module: v }));
                        } })] }), _jsxs("div", { children: [_jsx("label", { children: "Afficher facelift" }), _jsx("br", {}), _jsx("input", { value: (widget === null || widget === void 0 ? void 0 : widget.payload.showFacelift) || true, type: "checkbox", checked: widget === null || widget === void 0 ? void 0 : widget.payload.showFacelift, onClick: function (e) {
                            onChange &&
                                onChange(widget, __assign(__assign({}, widget.payload), { showFacelift: e.currentTarget.checked }));
                        } })] }), _jsxs("div", { children: [_jsx("label", { children: "Afficher les boutons d'actions" }), _jsx("br", {}), _jsx("input", { value: (widget === null || widget === void 0 ? void 0 : widget.payload.showActionButton) || true, type: "checkbox", checked: widget === null || widget === void 0 ? void 0 : widget.payload.showActionButton, onClick: function (e) {
                            onChange &&
                                onChange(widget, __assign(__assign({}, widget.payload), { showActionButton: e.currentTarget.checked }));
                        } })] }), _jsxs("div", { children: [_jsx("label", __assign({ htmlFor: "content-value", id: "content-value-label" }, { children: "First line" })), _jsx(Input, { slotProps: {
                            input: {
                                id: "first-line-value",
                                "aria-labelledby": "first-line-value first-line-value-label",
                            },
                        }, value: (widget === null || widget === void 0 ? void 0 : widget.payload.first) || "", placeholder: "Enter value like %(name)s", onChange: function (e) {
                            var value = e.target.value;
                            onChange && onChange(widget, __assign(__assign({}, widget.payload), { first: value }));
                        } }), _jsx("label", __assign({ htmlFor: "content-value", id: "content-value-label" }, { children: "Second line" })), _jsx(Input, { slotProps: {
                            input: {
                                id: "second-line-value",
                                "aria-labelledby": "second-line-value second-line-value-label",
                            },
                        }, value: (widget === null || widget === void 0 ? void 0 : widget.payload.second) || "", placeholder: "Enter value like %(fieldname)s", onChange: function (e) {
                            var value = e.target.value;
                            onChange && onChange(widget, __assign(__assign({}, widget.payload), { second: value }));
                        } }), _jsx("label", __assign({ htmlFor: "content-value", id: "content-value-label" }, { children: "Third line" })), _jsx(Input, { slotProps: {
                            input: {
                                id: "third-line-value",
                                "aria-labelledby": "third-line-value third-line-value-label",
                            },
                        }, value: (widget === null || widget === void 0 ? void 0 : widget.payload.third) || "", placeholder: "Enter value like %(fieldname)s", onChange: function (e) {
                            var value = e.target.value;
                            onChange && onChange(widget, __assign(__assign({}, widget.payload), { third: value }));
                        } }), _jsx("label", __assign({ htmlFor: "content-value", id: "content-value-label" }, { children: "Fourth line" })), _jsx(Input, { slotProps: {
                            input: {
                                id: "fourth-line-value",
                                "aria-labelledby": "fourth-line-value fourth-line-value-label",
                            },
                        }, value: (widget === null || widget === void 0 ? void 0 : widget.payload.fourth) || "", placeholder: "Enter value like %(fieldname)s", onChange: function (e) {
                            var value = e.target.value;
                            onChange && onChange(widget, __assign(__assign({}, widget.payload), { fourth: value }));
                        } })] }), _jsxs("div", __assign({ className: "py-2" }, { children: [_jsx("label", __assign({ htmlFor: "content-value", id: "content-value-label" }, { children: "Filter" })), _jsx(WidgetSelector, { widget: filter, onChange: onChange })] }))] }));
}
widgetsDictionary.register("widget/list", {
    name: "Widget liste",
    display: WidgetList,
    settings: WidgetSettings,
});
